import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arr-down",
  "use": "icon-arr-down-usage",
  "viewBox": "0 0 24 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 28\" id=\"icon-arr-down\"><path d=\"M0 17.6l1.4-1.8L2.8 14l2 1.8 5 4.4V0H14v20.4l5.4-4.6 2-1.8 1.2 1.8 1.4 1.8L12 28 0 17.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol